export default __webpack_public_path__ + "static/media/17@2x.bebd2e13.png";